import { render, staticRenderFns } from "./form-header.vue?vue&type=template&id=50430ef4&scoped=true"
import script from "./form-header.ts?vue&type=script&lang=ts&external"
export * from "./form-header.ts?vue&type=script&lang=ts&external"
import style0 from "./form-header.vue?vue&type=style&index=0&id=50430ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50430ef4",
  null
  
)

export default component.exports